import { HttpResponse } from '@angular/common/http';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FuseMockApiUtils } from '@fuse/lib/mock-api';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { ReportFileUploadService } from 'app/core/common/services/report-file-upload-service';
import { InwardReport } from 'app/modules/admin/transactions/inwards/reports.types';
import { WebcamImage } from 'ngx-webcam';
import { Subject, Observable } from 'rxjs';
import { UploadFileType } from './upload-multiple-image.types';

@Component({
    selector: 'app-upload-muliple-images',
    templateUrl: './upload-multiple-images.component.html',
    styleUrls: ['./upload-multiple-images.component.scss']
})
export class UploadMultipleImagesComponent implements OnInit {

    @Input() report: InwardReport;
    @Input() fileName: string;
    uploadForm: FormGroup;

    selectedFiles?: File[] = [];
    selectedFileNames: string[] = [];

    progressInfos: any[] = [];
    message: string[] = [];
    isReportDoc: boolean = false;
    preview: any;
    imageInfos?: Observable<any>;

    googleDrivePath: string;

    previews: string[] = [];

    uploadType: string = "Upload"


    private trigger = new Subject();
    public webcamImage!: WebcamImage;
    private nextWebcam = new Subject();
    captureImage = '';
    constructor(private uploadService: ReportFileUploadService,
        private alertService: AlertMessageService,
        private _matDialogRef: MatDialogRef<UploadMultipleImagesComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: {
            reportId: number,
            googleDrivePath: string,
            isReportDoc: boolean,
            inwardId: number
        }) {
        this.googleDrivePath = this._data.googleDrivePath
        this.isReportDoc = this._data.isReportDoc
    }

    ngOnInit(): void {

    }

    selectFiles(event: any): void {
        this.message = [];
        this.progressInfos = [];
        this.selectedFileNames = [];
        this.selectedFiles = event.target.files;
        this.previews = [];
        if (this.selectedFiles && this.selectedFiles.length > 0) {
            const numberOfFiles = this.selectedFiles.length;
            for (let i = 0; i < numberOfFiles; i++) {
                const reader = new FileReader();

                reader.onload = (e: any) => {
                    this.previews.push(e.target.result);
                };

                reader.readAsDataURL(this.selectedFiles[i]);

                this.selectedFileNames.push(this.selectedFiles[i].name);
            }
        }
    }

    uploadFiles(): void {
        this.message = [];
        if (this.selectedFiles && this.selectFiles.length > 0) {
            const formData: FormData = new FormData();
            for (let i = 0; i < this.selectedFiles.length; i++) {
                formData.append('Files', this.selectedFiles[i]);
            }
            formData.append('UploadFileType', UploadFileType[UploadFileType.Documents]);
            formData.append('GoogleDrivePath', this.googleDrivePath);
            formData.append('ReportId', this._data.reportId.toString());
            formData.append('InwardId', this._data.inwardId.toString());
            this.uploadService.multipleImageupload(formData).subscribe(
                event => {
                    if (event instanceof HttpResponse) {
                        const msg = 'Successful!';
                        this.alertService.success(msg);
                        this._matDialogRef.close();
                        // this.imageInfos = this.uploadService.getFiles();
                    }
                });
        }
    }

    uploadFilesReport(): void {
        this.message = [];
        if (this.selectedFiles && this.selectFiles.length > 0) {
            const formData: FormData = new FormData();
            for (let i = 0; i < this.selectedFiles.length; i++) {
                formData.append('Files', this.selectedFiles[i]);
            }
            formData.append('UploadFileType', "ReportImage");
            formData.append('GoogleDrivePath', this.googleDrivePath);
            formData.append('ReportId', this._data.reportId.toString());
            this.uploadService.multipleImageupload(formData).subscribe(
                event => {
                    if (event instanceof HttpResponse) {
                        const msg = 'Successful!';
                        this.alertService.success(msg);
                        this._matDialogRef.close();
                    }
                });
        }
    }


    onClose(): void {
        this._matDialogRef.close();
    }

    public handleImage(webcamImage: WebcamImage): void {
        this.webcamImage = webcamImage;
        this.captureImage = webcamImage!.imageAsDataUrl;
        //this.webcamImage = webcamImage;

        const file = this.dataURLtoFile(this.captureImage, `${FuseMockApiUtils.guid()}.png`);
        //let file = this.convertBase64ToFile(this.captureImage, `${FuseMockApiUtils.guid()}.png`);
        this.selectedFiles.push(file);
        this.previews.push(this.captureImage);
    }

    // public handleImage(webcamImage: WebcamImage): void {
    //     this.webcamImage = webcamImage;
    //     this.captureImage = webcamImage!.imageAsDataUrl;
    //     console.info('received webcam image', this.captureImage);
    // }

    public get triggerObservable(): Observable<any> {
        return this.trigger.asObservable();
    }

    public get nextWebcamObservable(): Observable<any> {
        return this.nextWebcam.asObservable();
    }

    onTypeChange(event) {
        switch (event.value) {
            case 'Snap':
                this.uploadType = "Snap"
                this.selectedFiles = []
                break;
            case 'Upload':
                this.uploadType = "Upload"
                this.selectedFiles = []
                break;
            case 'ReportImage':
                this.uploadType = "ReportImage"
                this.selectedFiles = []
                break;
            default:
                break;
        }
    }

    public triggerSnapshot(): void {
        this.trigger.next();
    }

    private dataURLtoFile(dataUrl: string, filename: string): File {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }
}
